import Vue from "vue";
import Vuex from "vuex";
import scanner from "./modules/scanner";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    scanner,
  },
});
